<template>
    <div class="dashboard__sidebar sidebar">
        <ul class="dashboard__nav">
            <router-link v-slot="{ isExactActive }" custom to="/auth/my-carconnex">
                <li
                    @click="changeActivity(navItem.welcome)"
                    :class="{ 'is-active': isExactActive }"
                    id="welcome"
                    class="dashboard__nav-item"
                    v-tippy="{
                        content: i18n.t('dashboardSidebar.dashboard'),
                        placement: 'right',
                    }"
                >
                    <router-link to="/auth/my-carconnex">
                        <svg class="sprite-icon icon__control" width="24" height="24">
                            <use xlink:href="/img/sprite.svg#filter-kilometers"></use>
                        </svg>
                    </router-link>
                </li>
            </router-link>
            <!-- <li
                v-if="!isApprovedCompany && !isProspect"
                id="orders"
                :class="{
                    'new-notify': indicators?.my_orders?.showNotificationIndicator,
                }"
                class="dashboard__nav-item"
                v-tippy="{
                    content: i18n.t('dashboardSidebar.myOrders'),
                    placement: 'right',
                }"
            >
                <a href="#" @click.prevent="showCompanyStatusDialog()">
                    <svg class="sprite-icon icon__order" width="24" height="24">
                        <use xlink:href="/img/sprite.svg#order"></use>
                    </svg>
                </a>
            </li> -->
            <router-link
                v-if="canShowOrdersPage && !isProspect"
                v-slot="{ isExactActive }"
                custom
                :to="
                    $route.path.includes('/auth/my-carconnex/my-orders/')
                        ? $route.path
                        : '/auth/my-carconnex/my-orders/to_approve'
                "
            >
                <li
                    @click="changeActivity(navItem.orders)"
                    :class="{
                        'is-active': isExactActive,
                        'new-notify': indicators?.my_orders?.showNotificationIndicator,
                    }"
                    id="orders"
                    class="dashboard__nav-item"
                    v-tippy="{
                        content: i18n.t('dashboardSidebar.myOrders'),
                        placement: 'right',
                    }"
                >
                    <router-link
                        :to="
                            $route.path.includes('/auth/my-carconnex/my-orders/')
                                ? $route.path
                                : '/auth/my-carconnex/my-orders/to_approve'
                        "
                    >
                        <svg class="sprite-icon icon__order" width="24" height="24">
                            <use xlink:href="/img/sprite.svg#order"></use>
                        </svg>
                    </router-link>
                </li>
            </router-link>
            <!--            <router-link-->
            <!--                v-slot="{ isExactActive }"-->
            <!--                custom-->
            <!--                to="/auth/my-carconnex/my-car-history"-->
            <!--                v-if="canShowOrderHistoryPage"-->
            <!--            >-->
            <!--                <li-->
            <!--                    @click="changeActivity(navItem.documents)"-->
            <!--                    :class="{-->
            <!--                        'is-active': isExactActive,-->
            <!--                        'new-notify':-->
            <!--                            indicators?.my_documents?.showNotificationIndicator,-->
            <!--                    }"-->
            <!--                    id="documents"-->
            <!--                    class="dashboard__nav-item"-->
            <!--                    v-tippy="{-->
            <!--                        content: i18n.t('dashboardSidebar.myCarHistory'),-->
            <!--                        placement: 'right',-->
            <!--                    }"-->
            <!--                >-->
            <!--                    <router-link to="/auth/my-carconnex/my-car-history">-->
            <!--                        <svg class="sprite-icon icon__files" width="24" height="24">-->
            <!--                            <use xlink:href="/img/sprite.svg#files"></use>-->
            <!--                        </svg>-->
            <!--                    </router-link>-->
            <!--                </li>-->
            <!--            </router-link>-->
            <router-link v-slot="{ isActive }" custom to="/auth/my-carconnex/my-account">
                <li
                    :class="{
                        'is-active': isActive,
                        'new-notify': indicators?.my_account?.showNotificationIndicator,
                    }"
                    id="account"
                    class="dashboard__nav-item"
                    v-tippy="{
                        content: i18n.t('dashboardSidebar.myAccount'),
                        placement: 'right',
                    }"
                >
                    <router-link to="/auth/my-carconnex/my-account">
                        <svg class="sprite-icon icon__user" width="24" height="24">
                            <use xlink:href="/img/sprite.svg#profile-user"></use>
                        </svg>
                    </router-link>
                </li>
            </router-link>
            <router-link v-slot="{ isActive }" custom to="/auth/my-carconnex/my-company">
                <li
                    :class="{
                        'is-active': isActive,
                        'new-notify': indicators?.my_company?.showNotificationIndicator,
                    }"
                    id="account"
                    class="dashboard__nav-item"
                    v-tippy="{
                        content: i18n.t('dashboardSidebar.myCompany'),
                        placement: 'right',
                    }"
                >
                    <router-link to="/auth/my-carconnex/my-company">
                        <svg class="sprite-icon icon__user" width="24" height="24">
                            <use xlink:href="/img/sprite.svg#users"></use>
                        </svg>
                    </router-link>
                </li>
            </router-link>
            <router-link
                v-if="false"
                v-slot="{ isExactActive }"
                custom
                to="/auth/my-carconnex/my-settings"
            >
                <li
                    @click="changeActivity(navItem.settings)"
                    :class="{
                        'is-active': isExactActive,
                        'new-notify': indicators?.my_settings?.showNotificationIndicator,
                    }"
                    id="settings"
                    class="dashboard__nav-item"
                    v-tippy="{
                        content: i18n.t('dashboardSidebar.mySettings'),
                        placement: 'right',
                    }"
                >
                    <router-link to="/auth/my-carconnex/my-settings">
                        <svg class="sprite-icon icon__gear" width="24" height="24">
                            <use xlink:href="/img/sprite.svg#cogwheel"></use>
                        </svg>
                    </router-link>
                </li>
            </router-link>
            <router-link
                v-slot="{ isExactActive }"
                custom
                to="/auth/my-carconnex/my-favorites"
                v-if="canShowFavoritesPage"
            >
                <li
                    @click="changeActivity(navItem.favorites)"
                    :class="{
                        'is-active': isExactActive,
                        'new-notify':
                            indicators?.my_favourites?.showNotificationIndicator,
                    }"
                    id="favorites"
                    class="dashboard__nav-item"
                    v-tippy="{
                        content: i18n.t('dashboardSidebar.myFavourites'),
                        placement: 'right',
                    }"
                >
                    <router-link to="/auth/my-carconnex/my-favorites">
                        <svg class="sprite-icon icon__heart" width="24" height="24">
                            <use xlink:href="/img/sprite.svg#heart"></use>
                        </svg>
                    </router-link>
                </li>
            </router-link>
        </ul>
        <div
            @click="ctx.logout()"
            class="dashboard__nav-item --logout"
            v-tippy="{
                content: i18n.t('dashboardSidebar.logOut'),
                placement: 'right',
            }"
        >
            <a href="#">
                <svg class="sprite-icon icon__logout" width="24" height="24">
                    <use xlink:href="/img/sprite.svg#logout"></use>
                </svg>
            </a>
        </div>
    </div>
</template>

<script lang="ts">
import { DashboardSidebar } from "@/dashboard/dashboard-sidebar/dashboard-sidebar";
export default DashboardSidebar;
</script>
<style scoped>
.sidebar {
    z-index: 100;
}
</style>
